import VersusBarChart from './VersusBarChart';
import './VersusBarChart.scss';

export default VersusBarChart;